import React from 'react';

const Logo = ({ className = "h-8 w-auto", variant = "auto" }) => {
  // Determine colors based on variant
  const getColors = () => {
    switch (variant) {
      case 'light':
        return {
          text: '#1f2937'
        };
      case 'dark':
        return {
          text: '#ffffff'
        };
      default: // 'auto' - works well on both light and dark backgrounds
        return {
          text: '#ffffff'
        };
    }
  };

  const colors = getColors();

  return (
    <svg 
      className={className}
      viewBox="0 0 160 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Text "Problem Spotter" */}
      <text 
        x="5" 
        y="18" 
        fontSize="14" 
        fontWeight="600" 
        fill={colors.text}
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        PROBLEM
      </text>
      <text 
        x="5" 
        y="32" 
        fontSize="14" 
        fontWeight="600" 
        fill={colors.text}
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        SPOTTER
      </text>
    </svg>
  );
};

export default Logo; 